import React, { Component } from 'react';

// SVG Icons
import IconPersonLeft from './icons/iconPersonLeft';
import IconPersonCenter from './icons/iconPersonCenter';
import IconPersonRight from './icons/iconPersonRight';
import Yelp from './icons/iconYelp';
import Dropbox from './icons/iconDropbox';
import Swarm from './icons/iconSwarm';
import Wordpress from './icons/iconWordpress';
import Whatsapp from './icons/iconWhatsapp';


class TheRightPeople extends Component {
  render() {
    return (
      <div className="the-right-people">

        <div className="wrap">

          <h2>Got an idea?</h2>

          <div className="icon-container">
              <Yelp />
              <Dropbox />
              <Swarm />
              <Wordpress />
              <Whatsapp />
          </div>

          <div className="person-container">
            <IconPersonLeft />
            <IconPersonCenter />
            <IconPersonRight />
          </div>

          <h3>Find the right<br />people!</h3>

        </div>

      </div>
    );
  }
}

export default TheRightPeople;



// WEBPACK FOOTER //
// ./src/assets/components/theRightPeople.js